import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import FundIcon from 'assets/images/funds/moneypool-2.png'
import Fund2Icon from 'assets/images/funds/moneyPool-1.svg'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
interface ISubHeaderProps {
    capital: number
    workingCapital: number
    intervalPotency: number
    date: string
    intervalShareIncome: number
    totalShares: number
    shareValueAmount: number
    cashinsAmount: number
    cashoutAmounts: number
    createDate: string
    imageId: number
    avatar: string | null
    name: string
    isFuckingManager: () => boolean
}
export default function SubHeader({
    capital,
    workingCapital,
    intervalPotency,
    date,
    intervalShareIncome,
    totalShares,
    shareValueAmount,
    cashinsAmount,
    cashoutAmounts,
    createDate,
    imageId,
    avatar,
    name,
    isFuckingManager,
}: ISubHeaderProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { state } = useLocation()
    return (
        <div className="bg-white w-full px-2">
            {/* Fund name — centered, 16sp, marginTop 6dp */}
            <p className="text-center text-base text-black mt-1.5 px-[22px]">
                {name}
            </p>

            {/* Info row: avatar on the RIGHT (RTL start), info to its left.
                Each row = label (right) + value (left). */}
            <div className="flex items-center gap-3 mt-[3px] mb-1 px-2">
                {avatar ? (
                    <img
                        src={avatar}
                        alt="fund"
                        className="w-20 h-20 shrink-0 rounded-full object-cover"
                    />
                ) : (
                    <img
                        src={imageId === 2 ? FundIcon : Fund2Icon}
                        alt="fund"
                        className="w-20 h-20 shrink-0 object-contain"
                    />
                )}
                <div className="flex-1 min-w-0 flex flex-col gap-1.5 text-sm">
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">سرمایه صندوق</span>
                        <span className="text-black">
                            {capital ? capital.toLocaleString() : 0} تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">سرمایه در گردش</span>
                        <span className="text-black">
                            {workingCapital
                                ? workingCapital.toLocaleString()
                                : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">توان دوره</span>
                        <span className="text-black">
                            {intervalPotency
                                ? intervalPotency.toLocaleString()
                                : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">تاریخ سررسید</span>
                        <span className="text-black">
                            {ConvertJalaliDate(date)}
                        </span>
                    </div>
                </div>
            </div>

            {/* More-info band: #EFEFEF, 1px gray stroke, 4px radius */}
            {isOpen && (
                <div className="mx-4 mt-[3px] rounded-[4px] border border-[#D4D4D4] bg-[#EFEFEF] px-4 py-1.5 text-sm flex flex-col gap-1.5">
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">ورودی ماهیانه</span>
                        <span className="text-black">
                            {intervalShareIncome
                                ? intervalShareIncome.toLocaleString()
                                : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">تعداد سهم ورودی</span>
                        <span className="text-black">
                            {totalShares ? totalShares.toLocaleString() : 0} سهم
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">حق عضویت پایه</span>
                        <span className="text-black">
                            {shareValueAmount
                                ? shareValueAmount.toLocaleString()
                                : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">مجموع واریزها</span>
                        <span className="text-black">
                            {cashinsAmount ? cashinsAmount.toLocaleString() : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">مجموع برداشت ها</span>
                        <span className="text-black">
                            {cashoutAmounts
                                ? cashoutAmounts.toLocaleString()
                                : 0}{' '}
                            تومان
                        </span>
                    </div>
                    <div className="flex justify-between gap-2">
                        <span className="text-text-muted">تاریخ ایجاد صندوق</span>
                        <span className="text-black">
                            {ConvertJalaliDate(createDate)}
                        </span>
                    </div>
                </div>
            )}

            {/* More/less toggle: blue text + chevron, bottom-rounded band */}
            <div className="flex justify-center mt-[3px]">
                <button
                    className="inline-flex items-center justify-center gap-2 rounded-b-[4px] border border-[#D4D4D4] bg-[#EFEFEF] px-2 py-0.5 text-sm font-bold text-[#2196F3]"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <svg
                        className={`w-4 h-4 transition-transform duration-300 ${
                            isOpen ? '' : 'rotate-180'
                        }`}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="18 15 12 9 6 15" />
                    </svg>
                    {isOpen ? 'اطلاعات کمتر' : 'اطلاعات بیشتر'}
                </button>
            </div>
        </div>
    )
}
